module.exports = __webpack_public_path__ + "img/mico-product-listing.c46b1104.webp";